export enum RateActionLetterTemplate {
  GENWORTH_7000K = 'genworth_7000k',
}

export const RATE_ACTION_LETTER_TEMPLATE_VALUES: ReadonlyArray<RateActionLetterTemplate> = [
  RateActionLetterTemplate.GENWORTH_7000K,
];

export function isRateActionLetterTemplate(v: unknown): v is RateActionLetterTemplate {
  return typeof v === 'string'
    && (RATE_ACTION_LETTER_TEMPLATE_VALUES as ReadonlyArray<string>).includes(v);
}
